import { render, staticRenderFns } from "./VideoRoomMeeting.vue?vue&type=template&id=01a7dfc8"
import script from "./VideoRoomMeeting.vue?vue&type=script&lang=js"
export * from "./VideoRoomMeeting.vue?vue&type=script&lang=js"
import style0 from "./VideoRoomMeeting.vue?vue&type=style&index=0&id=01a7dfc8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports